import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import type { ViewerManagerDocumentServicesModelApiEditorConfig } from './types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import { CarmiInstance, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

const viewerManagerDocumentServicesModelApiFactory = (
	publicModelApiConfig: ViewerManagerDocumentServicesModelApiEditorConfig,
	{ publicModel, documentServices, dsModel }: DSCarmi
): IViewerManagerImplementor<'documentServicesModel'> => {
	return {
		documentServicesModel: {
			updateIsPublished: (isPublished: boolean) => documentServices.set('isPublished', isPublished),
			getIsPublished: () => dsModel.isPublished,
			updatePublicUrl: (publicUrl: string) => documentServices.set('publicUrl', publicUrl),
			getPublicUrl: () => dsModel.publicUrl,
			updateRevision: (revision: number) => publicModel.updateSiteRevision(revision),
			getRevision: () => publicModelApiConfig.revision,
			updateSiteName: (siteName: string) => documentServices.set('siteName', siteName),
			getSiteName: () => dsModel.siteName,
			updateVersion: (version: number) => documentServices.set('version', version),
			getVersion: () => dsModel.version,
			updateCustomHeadTags: (customHeadTags: string) => documentServices.set('customHeadTags', customHeadTags),
			getCustomHeadTags: () => dsModel.customHeadTags,
		},
	}
}
export const ViewerManagerDocumentServicesModelApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), CarmiInstance],
	viewerManagerDocumentServicesModelApiFactory
)
